/**
 * Best Price Section PDP Logic - KALKI Fashion
 */
(function () {
  function formatMoneyAmount(cents, currencySymbol) {
    var symbol = currencySymbol || '$';
    var units = Math.round(cents / 100);
    // Use en-IN formatting for Rupee symbol, standard locale otherwise
    var formattedNum = (symbol === '$')
      ? units.toLocaleString('en-US')
      : units.toLocaleString();
    return symbol + formattedNum;
  }

  function initBestPrice() {
    var cards = document.querySelectorAll('[js-kalki-best-price]');
    cards.forEach(function (card) {
      var toggle = card.querySelector('[js-kalki-bp-toggle]');
      if (!toggle || toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';

      toggle.setAttribute('aria-expanded', card.classList.contains('is-open') ? 'true' : 'false');

      function handleToggle(e) {
        if (e) e.preventDefault();
        var isOpen = card.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      toggle.addEventListener('click', handleToggle);
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          handleToggle(e);
        }
      });
    });
  }

  function updateBestPriceForVariant(variant) {
    if (!variant) return;

    var cards = document.querySelectorAll('[js-kalki-best-price]');
    cards.forEach(function (card) {
      var price = Number(variant.price || 0);
      var comparePrice = Number(variant.compare_at_price || 0);
      var currencySymbol = card.getAttribute('data-currency-symbol') || '$';
      var hasOffer = card.getAttribute('data-has-offer') === 'true';
      var offerPercent = parseFloat(card.getAttribute('data-offer-percent')) || 0;
      var hasProductDiscount = comparePrice > price;

      var container = card.closest('.kalki-best-price-container');

      // Rule: If no offer and no product discount, hide entire section
      if (!hasOffer && !hasProductDiscount) {
        if (container) container.style.display = 'none';
        return;
      } else {
        if (container) container.style.display = '';
      }

      var maxDiscountCapCents = parseFloat(card.getAttribute('data-max-discount-cap')) || 0;

      // Offer discount: (price * offerPercent / 100), rounded to nearest unit
      var offerDiscountCents = 0;
      if (hasOffer && offerPercent > 0) {
        var priceUnits = price / 100;
        var offerDiscountUnits = Math.round(priceUnits * (offerPercent / 100));
        offerDiscountCents = offerDiscountUnits * 100;
      }

      // Apply 3rd pipe Max Discount Cap if specified
      if (maxDiscountCapCents > 0) {
        if (offerDiscountCents > maxDiscountCapCents || offerDiscountCents === 0) {
          offerDiscountCents = maxDiscountCapCents;
        }
      }

      var bestPriceCents = hasOffer ? Math.max(0, price - offerDiscountCents) : price;

      // Update Best Price in header
      var bestPriceEl = card.querySelector('[data-bp-best-price]');
      if (bestPriceEl) {
        bestPriceEl.textContent = formatMoneyAmount(bestPriceCents, currencySymbol);
      }

      // Update Offer / Max Tier discount row & value
      var offerRow = card.querySelector('.kalki-bp-offer-row, .kalki-bp-tier-row');
      var offerValEl = card.querySelector('[data-bp-max-tier-discount], [data-bp-offer-val], [data-bp-credit-val]');
      if (hasOffer) {
        if (offerValEl) {
          offerValEl.textContent = formatMoneyAmount(offerDiscountCents, currencySymbol);
        }
        if (offerRow) {
          offerRow.style.display = '';
        }
      } else {
        if (offerRow) {
          offerRow.style.display = 'none';
        }
      }

      // Update Product discount value & row visibility
      var discountRow = card.querySelector('[data-bp-discount-row]');
      var discountVal = card.querySelector('[data-bp-discount-val]');
      if (comparePrice > price) {
        var discountCents = comparePrice - price;
        if (discountVal) {
          discountVal.textContent = formatMoneyAmount(discountCents, currencySymbol);
        }
        if (discountRow) {
          discountRow.style.display = 'flex';
        }
      } else {
        if (discountRow) {
          discountRow.style.display = 'none';
        }
      }
    });
  }

  window.initKalkiBestPrice = initBestPrice;
  window.updateKalkiBestPrice = updateBestPriceForVariant;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestPrice);
  } else {
    initBestPrice();
  }

  // Subscribe to variant change events (Shopify Dawn PUB_SUB_EVENTS)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        updateBestPriceForVariant(event.data.variant);
      }
    });
  }

  // Also support custom events or section reload
  document.addEventListener('kalki:best-price:init', initBestPrice);
})();
